import React, { Component, PropTypes } from 'react';
import debounce from 'lodash/debounce';
import SubcategorySelect from 'common/containers/subcategory_select';
import Masonry from 'common/components/masonry';
import { LoadingIndicator } from 'common/components/preloader';
import Review from 'marketing/containers/review';

export default class Reviews extends Component {
  constructor(props) {
    super(props);

    this.state = { selectedSubcat: props.initialSubcat, lastScrollFetched: 0 };

    this.selectSubcat = this.selectSubcat.bind(this);
    this.fetch = this.fetch.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillUnmount() {
    this.props.clear();
    window.removeEventListener('scroll', this.handleScroll, true);
    this.setState({ lastScrollFetched: 0 });
  }

  componentDidMount() {
    this.fetch();
    window.addEventListener('scroll', this.handleScroll, true);
  }

  handleScroll = debounce((e) => {
    const { lastScrollFetched } = this.state;
    const { count, items, fetching } = this.props;
    const scrollTop = e.target.scrollTop;

    /* only fetch more if:
       - not fetching already
       - there are still items left
       - user has scrolled more than 500px since last fetch */
    if (!fetching && items.length < count && Math.abs(scrollTop - lastScrollFetched) > 500) {

      /* load more items, disabling scroll during fetch and resuming scroll position after it */
      e.target.setAttribute("style", "overflow: hidden");
      this.fetch().then(() => {
        e.target.setAttribute("style", "overflow: auto");
        e.target.scrollTop = scrollTop;
      })

      this.setState({ lastScrollFetched: scrollTop });
    }
  }, 50)

  fetch() {
    const { selectedSubcat } = this.state;
    const { fetch, oneToOneSubcats } = this.props;
    if (selectedSubcat) {
      let subcatIds = [selectedSubcat];
      if (selectedSubcat === "all") {
        subcatIds = null;
      } else if (selectedSubcat === "1to1") {
        subcatIds = oneToOneSubcats.map(s => s.id);
      }
      return fetch(subcatIds);
    }
  }

  selectSubcat(subcat) {
    this.setState({ selectedSubcat: subcat }, () => {
      this.props.clear();
      this.fetch();
    });
  }

  getItems() {
   return this.props.items.map(item => {
      return ({
        width: item.client_photo? "66%" : "32%",
        content: <Review item={item} />
      });
   });
  }

  render() {
    const { selectedSubcat } = this.state;
    const { items, fetching } = this.props;

    return (
      <section className="block block-reviews gray">
        <div className="row">
          <div className="columns small-16">
            <h3>Show crowdspring reviews for:</h3>
          </div>
        </div>
        <div className="row">
          <div className="columns small-16 medium-12 large-8 header-select">
            <SubcategorySelect meta={{}} value={selectedSubcat} input={{
              name: 'sub_category',
              onChange: this.selectSubcat
            }} include1to1Option={true} includeAllOption={true} />
          </div>
        </div>
        { selectedSubcat &&
        <div className="row">
          <div className="columns small-16">
            { items.length > 0 && <Masonry items={this.getItems()} gutterWidth="2%"/> }
            { items.length === 0 && !fetching && <h3>No reviews at the moment.</h3> }
          </div>
        </div> }
        { fetching &&
        <div className="row">
          <div className="columns small-16">
            <LoadingIndicator fullScreen={false}/>
          </div>
        </div> }
      </section>
    );
  }
};

Reviews.propTypes = {
  clear: PropTypes.func.isRequired,
  fetch: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  oneToOneSubcats: PropTypes.array.isRequired,
  count: PropTypes.number.isRequired,
  fetching: PropTypes.bool.isRequired,
  initialSubcat: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./marketing/components/reviews.jsx